import React from 'react'
import { RCDescription } from '../../../RCDescription/RCDescription'

import './RCContactSection.css'

const RCContactSection = ({ contactDetails, address }) => {
    const iframe = `<iframe class="rc-contact-section-map" src="https://maps.google.com/maps?q=${address}&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>`

    return (
        <div className="rc-contact-section">
            <RCDescription html={contactDetails} />
            <div dangerouslySetInnerHTML={{ __html: iframe }} />
        </div>
    )
}

export { RCContactSection }
